import React, { Suspense, useEffect, useState } from 'react';

const SuspenseHelper = ({ fallback, children }) => {
  const isSSR = typeof window === `undefined`;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
    }
  }, []);

  return (
    <Suspense fallback={fallback}>
      {isSSR || !isMounted ? fallback : children}
    </Suspense>
  );
};

export default SuspenseHelper;
